@if (mfaIsConfigurable$ | async) {
  <div class="row form-row">
    @if (userSettingsModalFF()) {
      <div class="col-12 center-vertically">
        <ds-toggle
          [label]="'mfa_form_label' | translate"
          [labelPosition]="DsToggleLabelPosition.BEFORE"
          [checked]="(mfaStatus$ | async) === $mfaStatus.enabled"
          (valueChange)="onMfaToggleChange($event)"
          [disabled]="(mfaStatus$ | async) !== $mfaStatus.enabled && !canEnableMfa"
        ></ds-toggle>
      </div>
    } @else {
      <div class="col-4 center-vertically">
        <label class="mfa-label">{{ 'mfa_form_label' | translate }}</label>
      </div>
      @if ((mfaStatus$ | async) === $mfaStatus.enabled) {
        <div class="col-8 center-vertically gap-3 gap-sm-5">
          <div data-test-id="mfa-configured">
            <ds-icon
              [icon]="Icons.CircleCheck"
              [iconStyle]="IconStyles.Solid"
              [style.color]="EapColors.GreenSeverityLow"
            ></ds-icon>
            <span class="margin-left-xs">{{ 'configured' | translate }}</span>
          </div>
          <button
            ds-button
            [variant]="DsButtonVariants.microAction"
            [microActionIcon]="Icons.TrashCan"
            id="disable-mfa-button"
            type="button"
            (click)="openDisableMfaModal()"
          >
            {{ 'remove' | translate }}
          </button>
        </div>
      } @else {
        <div class="col-8 center-vertically">
          <button
            ds-button
            [variant]="DsButtonVariants.microAction"
            [hideMicroActionIcon]="true"
            id="enable-mfa-button"
            type="button"
            (click)="enableMfa.emit()"
            [disabled]="!canEnableMfa"
          >
            {{ 'mfa_turn_on_mfa' | translate }}
          </button>
        </div>
      }
    }
  </div>
}
